import { lightTheme } from 'hfs-common-ui';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import type { PieChartData } from '~/domain/dashboard/models/pie-chart-model.';
import {
  type AppGatewaysWidgetData,
  type AppGatewaysResponse as BFFAppGatewaysResponse,
  type AppGatewaysStatusCategory,
  AppGatewaysStatus,
} from '../models/AppGatewaysResponse';

export const getFillColor = (category: AppGatewaysStatusCategory): string => {
  switch (category.state) {
    case AppGatewaysStatus.ONLINE:
      return lightTheme.colors.green500;
    case AppGatewaysStatus.OFFLINE:
      return lightTheme.colors.red500;
    case AppGatewaysStatus.NEEDS_ATTENTION:
      return lightTheme.colors.yellow500;
  }
};

export const getDirectConnectChartData = (
  response: BFFAppGatewaysResponse | undefined
): PieChartData[] => {
  return response
    ? response.gatewayStatuses?.map((status) => ({
        value: status.numberOfMachines,
        name: formatMessageWrapper(status.translationKey),
        fill: getFillColor(status),
        custom: status,
        status: status.state,
        keyName: status.state,
      })) || []
    : [];
};

export const transformAppGatewaysChartData = (
  data: BFFAppGatewaysResponse
): AppGatewaysWidgetData => ({
  chartData: getDirectConnectChartData(data),
  totalNumberOfMachines: data ? data.totalNumberOfMachines : 0,
});
